import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

import {getShippingMethodIconSrc} from "utils/ShippingMethods";
import {getShippingMethodName} from "views/oms/OrderList/utils/getShippingMethodName";
import {groupShipmentsByInventory} from "views/oms/OrderList/utils/groupShipmentsByInventory";
import {groupShipmentsByMethod} from "views/oms/OrderList/utils/groupShipmentsByMethod";

ZoneAndType.propTypes = {
    shipments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        shippingMethod: PropTypes.shape({
            discr: PropTypes.string.isRequired,
            name: PropTypes.string,
            shippingMethodShopName: PropTypes.string
        }),
        inventory: PropTypes.shape({
            '@id': PropTypes.string,
            inventoryCenterName: PropTypes.string
        })
    })).isRequired
};

function ZoneAndType({shipments}) {
    const groupedShipments = groupShipmentsByInventory(shipments);

    return Object.values(groupedShipments).map((group) => (
        <div key={group.inventoryId}>
            {group.inventoryId !== null && (
                <Badge
                    color={'info'}
                    size={'large'}
                    rounded
                    labelSize={14}
                    isBold={false}
                    border
                    themeExtension={{padding: {large: '8px'}}}
                >
                    {group.inventoryName}
                </Badge>
            )}
            <ul style={{listStyleType: 'none', paddingLeft: 0, marginTop: '4px'}}>
                {groupShipmentsByMethod(group.shipments).map((methodGroup, index) => {
                    const shippingMethod = methodGroup.shippingMethod;
                    const iconSrc = getShippingMethodIconSrc(shippingMethod?.discr);

                    return (
                        <li key={index} style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                            {getShippingMethodName(shippingMethod)}
                            {methodGroup.count > 1 && ` (${methodGroup.count})`}
                            {iconSrc && (
                                <img
                                    src={iconSrc}
                                    alt={shippingMethod?.discr}
                                    style={{width: '12px', height: '12px'}}
                                />
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    ));
}

export default ZoneAndType;
